document.addEventListener('DOMContentLoaded', () => {
  const labels = document.querySelector('[data-jr-product-labels]');
  const productInfo = document.querySelector('#MainContent .product__info-container');
  if (labels && productInfo) {
    const stock = labels.querySelector('[data-jr-limited-stock]');
    const quantity = productInfo.querySelector('.product-form__quantity');
    const stockAnchor = quantity || productInfo.querySelector('product-form');
    if (stock && stockAnchor && !productInfo.querySelector('.limited-stock')) {
      stockAnchor.insertAdjacentElement('beforebegin', stock);
    }
    labels.remove();
  }
  if (document.querySelector('[data-jr-simple-purchase]')) {
    document.querySelectorAll('#MainContent form').forEach(form => {
      if (new URL(form.action, location.href).pathname !== (window.routes?.cart_add_url || '/cart/add')) return;
      const channel = document.createElement('input');
      channel.type = 'hidden';
      channel.name = 'properties[_JuneReedOffer]';
      channel.value = 'standard';
      form.append(channel);
    });
  }
});
